var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9 22.7H5.1c-1.7 0-3.1-1.4-3.1-3.1V9.2c0-1 .5-2 1.3-2.5l6.9-4.8c1.1-.7 2.5-.7 3.5 0l6.9 4.8c.8.6 1.3 1.5 1.3 2.5v10.4c0 1.7-1.3 3.1-3 3.1zM12 3.3c-.2 0-.4.1-.6.2L4.5 8.3c-.3.2-.4.5-.4.9v10.4c0 .6.5 1.1 1.1 1.1h13.7c.6 0 1.1-.5 1.1-1.1V9.2c0-.4-.2-.7-.5-.9l-6.9-4.8c-.2-.1-.4-.2-.6-.2z",
    fill: "#050505"
  })));
}

export default SvgIconHome;